<template>
  <div class="vehicle-category-main">
    <div>
      <Menus :menu="menu" :menuWidth="215" @menuClicked="menuClicked" />
    </div>
    <div class="vehicle-category-table">
      <TableBox :tableData="VehicleCategoryList" :selectedRow.sync="selectedArea" title="Vehicle Category"
        :dataType="columnTypeMain" :hideColumns="['Seq No']"/>
    </div>
    <PopupEntry :show.sync="popupEntryShow" v-if="popupEntryShow" :title="popupEntryTitle" :updatedBy="updatedBy" :createdBy="createdBy"
      @save="saveClicked" :requiredError="entryRequired" :successMessages="entrySuccess" :messages="entryMessages"
      :errorMessages="entryError" @requiredClicked="entryRequiredClicked" :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'">
      <div class="General Details" style="display : flex; height : 100%;">
        <!-- General Details -->
        <div class="gen-details-right" placeholder="Category Code">
          <InputQuery placeholder="Category Code (max. 10 characters)" :isDisabled="viewModePK" :selectedObject.sync="categoryCode" 
            :search.sync="categoryCodeSearch" :items="categoryData" itemKey="Category Code" :allowFreeText="true" descKey="Description" :isRequired="true" :errorMessage.sync="categoryError" ref="category_code"
            @focusChanged="categoryTypeInputQueryFocusChanged"
            @selected="categoryTypeInputQueryItemSelected" />

          <Input :isDisabled="viewModeAuto" placeholder="Seq No (Auto Generated)" :inputValue.sync="seqNo" />
          <Input :isDisabled="viewMode || descriptionInputIsDisabled" placeholder="Description (max. 60 characters)"
            :inputValue.sync="categoryDescription" :errorMessage.sync="descriptionError" ref="category_description" 
            :isRequired="true" validator="text,60"/>
          <Input :isDisabled="viewMode" placeholder="Type" :inputValue.sync="categoryType" :errorMessage.sync="categoryTypeError" ref="category_type" validator="text,10"/>
          <Input :isDisabled="viewMode" placeholder="Type Description" :inputValue.sync="categoryTypeDescription" :errorMessage.sync="categoryTypeDescriptionError" ref="category_typeDesc" validator="text,60"/>
          <Input :isDisabled="viewMode" placeholder="Toll Class" :inputValue.sync="tollClass" :errorMessage.sync="tollClassError" ref="category_tollClass" validator="text,1"/>
          <Input :isDisabled="viewMode" placeholder="Avg Fuel Consumption per KM" :inputValue.sync="avgFuelConPerKM" validator="decimal,4,3" :errorMessage.sync="avgFuelConPerKMError" ref="category_avgFuelConPerKM" />
          <Input :isDisabled="viewMode" placeholder="KM per Litre KPI" :inputValue.sync="KMperLitreKPI" :errorMessage.sync="KMperLitreKPIError" ref="category_kpi" validator="decimal,4,3"/>
          <Dropdown :isDisabled="viewMode" placeholder="Block For Inspection" :selectedObject.sync="blockInspection"
            :items="optionsForDropdown" itemKey="label" style="padding-bottom: 30px;" />
          <Input v-if="showBlockInspectionNumberOfDays" :isDisabled="viewMode"
            placeholder="Days Before Block For Inspection" :inputValue.sync="numberOfDays" validator="integer,3" :errorMessage.sync="numberOfDaysError" ref="category_numberOfDays" />
          <Dropdown :isDisabled="viewMode" placeholder="Block For Road Tax" :selectedObject.sync="blockRoadTax"
            :items="optionsForDropdown" itemKey="label" style="padding-bottom: 30px;" />
          <Input v-if="showBlockRoadTaxNumberOfDays" :isDisabled="viewMode" placeholder="Days Before Block For Road Tax"
            :inputValue.sync="blockRoadTaxDays" validator="integer,3" :errorMessage.sync="blockRoadTaxDaysError" ref="category_blockRoadTaxDays" />
          <Dropdown placeholder="TMS Operations?" :isDisabled="viewMode" :items="optionsForDropdown" itemKey="label"
            :selectedObject.sync="TMSOperations" :isRequired="true" :errorMessage.sync="TMSOperationsError" ref="tms_operations" />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
    showBlockInspectionNumberOfDays: function () {
      if (!this.blockInspection) {
        return false;
      }
      return this.blockInspection.label == 'Yes';
    },
    showBlockRoadTaxNumberOfDays: function () {
      if (!this.blockRoadTax) {
        return false;
      }
      return this.blockRoadTax.label == 'Yes';
    },
  },
  data: function () {
    return {
      menu: [
        { title: 'New Vehicle Category', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png', key: 'MnuNew', visible: true, enabled: true },
        { title: 'Edit Vehicle Category', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png', key: 'MnuEdit', visible: true, enabled: true },
        { title: 'Delete Vehicle Category', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png', key: 'MnuDelete', visible: true, enabled: true }, //api response logic abit weird ("Hide Delete" instead of "Delete")
        { title: 'View Vehicle Category', icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png', key: 'MnuQuery', visible: true, enabled: true },
      ],
      VehicleCategoryList: [],
      viewMode: false,
      viewModePK: false,
      viewModeAuto: false,
      popupEntryShow: false,
      menuType: '',
      categoryCode: null, categoryError: '',
      categoryCodeSearch: '',
      seqNo: '',
      categoryDescription: '', descriptionError: '',
      descriptionInputIsDisabled: true,
      categoryType: '', categoryTypeError: '',
      categoryTypeDescription: '', categoryTypeDescriptionError: '',
      tollClass: '', tollClassError: '',
      avgFuelConPerKM: '', avgFuelConPerKMError: '',
      KMperLitreKPI: '', KMperLitreKPIError: '',
      blockInspection: null,
      numberOfDays: '', numberOfDaysError: '',
      blockRoadTax: null,
      blockRoadTaxDays: '', blockRoadTaxDaysError: '',
      TMSOperations: null, TMSOperationsError: '',
      entryRequired: [],
      entrySuccess: [],
      entryMessages: [],
      entryError: [],
      selectedArea: [],
      selectedOriginalArea: null,
      categoryData: [],
      optionsForDropdown: [
        { "label": "Yes", "API_Value": "1" },
        { "label": "No", "API_Value": "0" },
      ],
      columnTypeMain: {
        "#": "number",
        "Seq No (Auto Generated)": "number",
        "Toll Class": "number",
        "Avg Fuel Consumption per KM": "number",
        "KM per Litre KPI": "number",
        "Number of Days": "number",
      },
    };
  },
  props: {
  },
  methods: {
    entryRequiredClicked: function (item) {
      this.$refs[item].setFocus();
    },
    getVehicleCategoryList: async function () {
      this.VehicleCategoryList = [];
      this.$fullscreenLoading('Getting Vehicle Categories');
      this.VehicleCategoryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'vehiclecategory' });
      this.$fullscreenLoading();
    },
    getDropdownData: async function () {
      this.categoryData = [];
      this.$fullscreenLoading('Getting Vehicle Category');
      this.categoryData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLECATEGORY_UNIQUE' });
      this.$fullscreenLoading();
    },
    getCategoryCode: async function () {
      this.$fullscreenLoading('Getting Category Codes');
      this.categoryData = [];
      this.categoryData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLECATEGORY_UNIQUE', action: 'N' });
      this.$fullscreenLoading();
    },
    menuClicked: async function (e) {
      this.clearEntryMessages();
      this.clearAllFields();
      switch (e.title) {
        case 'New Vehicle Category':
          this.clearAllFields();
          this.getDropdownData();
          this.viewMode = false;
          this.viewModePK = false;
          this.viewModeAuto = true,
            this.popupEntryShow = true;
          this.descriptionInputIsDisabled = true;
          this.popupEntryTitle = 'New Vehicle Category';
          this.updatedBy = '';
          this.createdBy= '';
          this.menuType = 'New';
          this.TMSOperations = this.optionsForDropdown[1];
          break;
        case 'Edit Vehicle Category':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Vehicle Category Selected', 'Please select a Vehicle Category to edit');
          } else {
            this.viewMode = false;
            this.viewModePK = true;
            this.viewModeAuto = true,
              this.popupEntryShow = true;
            this.descriptionInputIsDisabled = false;
            this.popupEntryTitle = 'Edit Vehicle Category';
            this.selectedOriginalArea = JSON.parse(JSON.stringify(this.selectedArea[0]));
            await this.populateViewDetails(this.selectedArea[0]['Category Code'], this.selectedArea[0]['Seq No'])
          }
          break;
        case 'Delete Vehicle Category':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Vehicle Category Selected', 'Please select a Vehicle Category to delete');
          } else {
            let deleting = await this.$showAlert('warning', 'Delete Vehicle Category', `Are you sure you want to delete Vehicle Category for ${this.selectedArea[0]['Category Code']}?`, [
              { text: 'Delete', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ]);
            if (deleting == 'Delete') {
              let result = await this.$apiCallV2('/VehicleCategory/SaveVehicleCategory', {
                action: 'D',
                categorycode: this.selectedArea[0]['Category Code'], type: this.selectedArea[0]['Type']
              });
              if (result[0]['Results'] == 0) { // Delete successful
                this.$showAlert('success', 'Vehicle Category Deleted', `Successfully deleted Vehicle Category for ${this.selectedArea[0]['Category Code']}`);
                this.$nextTick(async () => await this.getVehicleCategoryList());
              } else { // Delete error
                this.$showAlert('error', 'Vehicle Category NOT Deleted', `There was an error deleting Vehicle Category for ${this.selectedArea[0]['Category Code']}`);
              }
            }
          }
          this.selectedArea = [];
          break;
        case 'View Vehicle Category':
          if (this.selectedArea.length == 0) {
            this.$showAlert('error', 'No Vehicle Category Selected', 'Please select a Vehicle Category to view');
          } else {
            this.viewMode = true;
            this.popupEntryShow = true;
            this.viewModePK = true;
            this.viewModeAuto = true,
              this.popupEntryTitle = 'View Category';
            await this.populateViewDetails(this.selectedArea[0]['Category Code'], this.selectedArea[0]['Seq No'])
          }
          break;
      }
    },
    clearAllFields: function () {
      this.categoryCode = null;
      this.categoryCodeSearch = '';
      this.categoryError = '';
      this.seqNo = '';
      this.categoryDescription = '';
      this.descriptionError = '';
      this.categoryType = '';
      this.categoryTypeError = '';
      this.categoryTypeDescription = '';
      this.categoryTypeDescriptionError = '';
      this.tollClass = '';
      this.tollClassError = '';
      this.avgFuelConPerKM = '';
      this.avgFuelConPerKMError = '';
      this.KMperLitreKPI = '';
      this.KMperLitreKPIError = '';
      this.blockInspection = null;
      this.numberOfDays = '';
      this.numberOfDaysError = '';
      this.blockRoadTax = null;
      this.blockRoadTaxDays = '';
      this.blockRoadTaxDaysError = '';
      this.TMSOperations = null;
      this.TMSOperationsError = null;
      this.menuType = '';
      this.createdBy = '';
      this.updatedBy = '';
    },
    categoryTypeInputQueryFocusChanged: async function (focused) {
      if (focused) { // if user clicked into inputquery
        return;
      }

      let areaExists = false;
      this.categoryData.forEach(c => {
        if (c['Category Code'] == this.categoryCodeSearch.toUpperCase()) { // found a match
          this.categoryDescription = c["Description"];
          this.descriptionInputIsDisabled = true;
          areaExists = true;
        }
      });
      if (!areaExists) {
        let alert = await this.$showAlert('Warning', 'Vehicle Category Code does not exist.', 'Add New Vehicle Category Code?', [
          { text: 'Confirm', color: 'green', textColor: 'white' },
          { text: 'Cancel', color: 'red', textColor: 'white' },
        ]);
        if (alert == 'Cancel') {
          this.clearAllFields();
          this.descriptionInputIsDisabled = true;
        } else {
          this.descriptionInputIsDisabled = false;
          this.categoryDescription = "";
        }
      }
    },
    categoryTypeInputQueryItemSelected: function(selectedCategory) {
      if (!selectedCategory) { // if nothing was selected or the user deselected
        return;
      }

      this.categoryDescription = selectedCategory["Description"];
      this.descriptionError= '';
      this.descriptionInputIsDisabled = true;
    },
    checkFields: function () {
      this.clearEntryMessages();
      if (!this.categoryCode && !this.categoryCodeSearch) {
        this.categoryError = 'Vehicle Category Code is required!';
        this.entryRequired.push({ key: 'category_code', value: 'Vehicle Category Code is required!' });
      }
      else if (this.categoryCodeSearch) {
        if (this.categoryCodeSearch.length > 10) {
          this.categoryError = 'Vehicle Category Code cannot exceed 10 characters!';
          this.entryRequired.push({ key: 'category_code', value: 'Vehicle Category Code cannot exceed 10 characters!' });
        }
      }
      if (!this.categoryDescription) {
        this.descriptionError = 'Vehicle Category Description is required!';
        this.entryRequired.push({ key: 'category_description', value: 'Vehicle Category Description is required!' });
      }
      else {
        if (this.categoryDescription.length > 60) {
          this.descriptionError = 'Vehicle Category Description cannot exceed 60 characters!'
          this.entryRequired.push({ key: 'category_description', value: 'Vehicle Category Description cannot exceed 60 characters!' });
        }
      }
      if (this.categoryType.length > 10) {
        this.categoryTypeError = 'Vehicle Category Type cannot exceed 10 characters!'
        this.entryRequired.push({ key: 'category_type', value: 'Vehicle Category Type cannot exceed 10 characters!' });
      }
      if (this.categoryTypeDescription.length > 60) {
        this.categoryTypeDescriptionError = 'Vehicle Category Type Description cannot exceed 60 characters!'
        this.entryRequired.push({ key: 'category_typeDesc', value: 'Vehicle Category Type Description cannot exceed 10 characters!' });
      }
      if (this.tollClass.length > 1) {
        this.tollClassError = 'Toll Class cannot exceed 1 character!'
        this.entryRequired.push({ key: 'category_tollClass', value: 'Toll Class cannot exceed 1 character!' });
      }
      if (!this.avgFuelConPerKM.match(/^\d*\.?\d*$/g) && this.avgFuelConPerKM) {
        this.avgFuelConPerKMError = 'Avg Fuel Consumption per KM format error!';
        this.entryRequired.push({ key: 'category_avgFuelConPerKM', value: 'Avg Fuel Consumption per KM format error! Please make sure input is in proper decimal format.' });
      }
      else {
        if (+this.avgFuelConPerKM > 900000000000000) {
          this.avgFuelConPerKMError = 'Avg Fuel Consumption per KM cannot exceed 900000000000000!';
          this.entryRequired.push({ key: 'category_avgFuelConPerKM', value: this.avgFuelConPerKMError });
        }
      }
      if (!this.KMperLitreKPI.match(/^\d*\.?\d*$/g) && this.KMperLitreKPI) {
        this.KMperLitreKPIError = 'KM per Litre KPI format error!';
        this.entryRequired.push({ key: 'category_kpi', value: 'KM per Litre KPI format error! Please make sure input is in proper decimal format.' });
      }
      else {
        if (+this.KMperLitreKPI > 900000000000000) {
          this.KMperLitreKPIError = 'KM per Litre KPI cannot exceed 900000000000000!';
          this.entryRequired.push({ key: 'category_kpi', value: this.KMperLitreKPIError });
        }
      }
      if (this.blockInspection && this.blockInspection['label'] == "Yes") {
        if (+this.numberOfDays > 255) {
          this.numberOfDaysError = 'Days Before Block For Inspection cannot exceed 255!'
          this.entryRequired.push({ key: 'category_numberOfDays', value: this.numberOfDaysError });
        }
      }
      if (this.blockRoadTax && this.blockRoadTax['label'] == "Yes") {
        if (+this.blockRoadTaxDays > 255) {
          this.blockRoadTaxDaysError = 'Days Before Block For Road Tax cannot exceed 255!'
          this.entryRequired.push({ key: 'category_blockRoadTaxDays', value: this.blockRoadTaxDaysError });
        }
      }
      if(!this.TMSOperations){
        this.TMSOperationsError = 'TMS Operations is required!'
        this.entryRequired.push({ key: 'tms_operations', value: 'TMS Operations is required!' });
      }
      return this.entryRequired.length > 0;
    },
    clearEntryMessages: function () {
      this.entryRequired = [];
      this.entrySuccess = [];
      this.entryMessages = [];
      this.entryError = [];
    },
    populateTextTrim: function (text) { // To populate text with trim
      return text ? text.trim() : '';
    },
    saveClicked: async function () {
      let isNotValid = this.checkFields();
      if (!isNotValid) {
        let action = this.popupEntryTitle[0];
        if (action == 'E') {
          if (this.selectedOriginalArea['Description'] != this.categoryDescription) {
            let change = await this.$showAlert('warning', 'Edit Vehicle Category', `Are you sure you want to edit Vehicle Category Description for all data with the description of "<b>${this.selectedOriginalArea['Description']}</b>" to "<b>${this.categoryDescription}</b>"`, [
              { text: 'Confirm', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ]);
            if (change == 'Cancel') {
              return;
            }
          }
        }
        let dataToPost = {
          'seqno': this.seqNo,
          'categorycode': this.categoryCodeSearch.toUpperCase(),
          'action': action,//actionflag
          'tollclass': this.tollClass,
          'avgfuelconperkm': Math.round(this.avgFuelConPerKM * 100) / 100,
          'kpikmperlitre': Math.round(this.KMperLitreKPI * 10) / 10,
          'expinspectblockop': this.blockInspection && this.blockInspection.API_Value ? this.blockInspection.API_Value : '',
          'expinspectblockdaysbefore': this.blockInspection && this.blockInspection.API_Value == 1 ? this.numberOfDays : '',
          'exroadtaxblockop': this.blockRoadTax && this.blockRoadTax.API_Value ? this.blockRoadTax.API_Value : '',
          'exroadtaxblockdaysbefore': this.blockRoadTax && this.blockRoadTax.API_Value == 1 ? this.blockRoadTaxDays : '',
          'includeintmsopr': this.TMSOperations && this.TMSOperations.API_Value ? this.TMSOperations.API_Value : '',
          'categorydesc': this.categoryDescription.toUpperCase(),
          'type': this.categoryType.toUpperCase(),
          'typedesc': this.categoryTypeDescription,
        };
        let loadingText = dataToPost['Action'] == 'D' ? 'Deleting Vehicle Category' : 'Saving Vehicle Category';
        this.$fullscreenLoading(loadingText);
        let result = await this.$apiCallV2('/VehicleCategory/SaveVehicleCategory', dataToPost);
        this.$nextTick(async () => await this.getVehicleCategoryList());
        this.$fullscreenLoading();
        if (result[0]['Results'] == 0) { // Save successful
          if (action == 'N') {
            this.entrySuccess.push(`Successfully created Vehicle Category for the Category Code: ${this.categoryCodeSearch}`);
            this.getCategoryCode();
          } else {
            this.entrySuccess.push(`Successfully edited Vehicle Category for the Category Code: ${this.categoryCodeSearch}`);
          }
          this.viewMode = true;
          this.viewModePK = true;
        } else { // Save error
          if (action == 'N') {
            this.entryError.push(`There was an error creating Vehicle Category: ${result[0]['ErrMsg']}`);
          } else {
            this.entryError.push(`There was an error editing Vehicle Category: ${result[0]['ErrMsg']}`);
          }
        }
      }
    },
    populateViewDetails: async function (record, seq_no) {
      this.$fullscreenLoading('Getting Details');
      let details = (await this.$apiCallV2(`/VehicleCategory/GetDetailsMaster?masterfile=vehiclecategory&recordid=${record}&seqno=${seq_no}`))['VehicleCat'];
      this.categoryCode = this.populateObject(this.categoryData, 'Category Code', details['CategoryCode']);
      this.seqNo = this.populateTextTrim(details['SeqNo']);
      this.tollClass = this.populateTextTrim(details['TollClass']);
      this.avgFuelConPerKM = this.populateTextTrim(details['AvgFuelConPerKM']);
      this.KMperLitreKPI = this.populateTextTrim(details['KPI_KMperLITRE']);
      this.blockInspection = this.populateObject(this.optionsForDropdown, 'API_Value', details['ExpInspectBlockOp']);
      this.numberOfDays = this.populateTextTrim(details['ExpInspectBlockDaysBefore']);
      this.blockRoadTax = this.populateObject(this.optionsForDropdown, 'API_Value', details['ExRoadTaxBlockOp']);
      this.blockRoadTaxDays = this.populateTextTrim(details['ExRoadTaxBlockDaysBefore']);
      this.TMSOperations = this.populateObject(this.optionsForDropdown, 'API_Value', details['IncludeInTMSOpr']);
      this.categoryDescription = this.populateTextTrim(details['CategoryDesc']);
      this.categoryType = this.populateTextTrim(details['Type']);
      this.categoryTypeDescription = this.populateTextTrim(details['TypeDesc']);
      this.updatedBy = `${details['UserID'] ? details['UserID'].trim() : ''} ${details['DateUpdated'] ? this.$dateTime.getDateTime(new Date(details['DateUpdated']), 'dd/MM/yyyy HH:mm') : ''}`;
      this.$fullscreenLoading();
    },
    populateObject: function (data, key, compare) { // To populate object into dropdown or input query
      try {
        return data.find(d => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Vehicle Category') {
        x.data.forEach(k => {
          //key in menu same as control value from api
          let selectedMenu = this.menu.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        })
      }
    })
    this.$fullscreenLoading('Getting Vehicle Category');
    this.VehicleCategoryList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'vehiclecategory' });
    this.$fullscreenLoading('Getting Vehicle Category');
    this.categoryData = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'VEHICLECATEGORY_UNIQUE' });
    this.$fullscreenLoading();
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.vehicle-category-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;
  .vehicle-category-table {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }
  .gen-details-right {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
</style>